export enum SplitBy {
    NONE = "no-split",
    CHOCOLATE = "chocolate",
    FILLING = "filling"
}